import httpManager from "@/app/shared/utils/httpManager";

export async function fetchViewerCampaigns(entityId, params) {
  const entity = entityId || "";
  const portfolio = params?.portfolio || "";
  const url = `/queues/monitoring?entity=${entity}&portfolio=${portfolio}`;
  const response = await httpManager.get(url);
  return response.data.results;
}
